import type { FaireProductEntity } from "../../entity_types/product";

export const p_gdanjsmtsf: FaireProductEntity = {
  token: "p_gdanjsmtsf",
  type: "product",
  name: "Garden Shed Soy Candle / 2026 Spring Collection",
  brandToken: "b_yynur8ww",
  brandName: "Good & Well Supply Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/9b9e854dd1d5bd2f1bbbd41c0fe0459c7f478282649dbeda0daa780271ee149a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/60a6a7dd4d0d4817712428acaaa36b622038f8d135ae8b7021ff6744c38dc967.png",
    "https://cdn.faire.com/fastly/30b12bdf448d45c6830f779e5e8a3544db9589a849a0c91dbf2e0666d984e371.png",
  ],
  priceDollars: 13,
  description:
    "Bergamot · Sage · Tangerine · Sunshine\n\nThere's nothing like the quiet of a garden shed--a little mess, a little sun, and the thrill of new beginnings. Garden Shed smells like juicy tangerine, sun-warmed bergamot, freshly cut sage and golden spring light. A fresh start, in scent form.\n\nDiameter: 3 in\nHeight: 3 in\nApprox. Net Wt: 8 oz \nApprox. Burn time: 40+ hours\nPhthalate Free\nMade in USA\n\nGood & Well Supply Co. crafts clean candles that celebrate the human connection with nature and inspire exploration. We donate 1% of our annual revenue to nonprofit organizations that protect and conserve national parks and public lands and promote inclusion in the outdoors.\n\nTESTER POLICY:\nLimited to one tester per scent. Testers are 2-oz candles with an easy-to-remove lid for in-store smelling.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:00.862Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
